<template>
  <v-app id="inspire">
    <!-- Add a navigation bar -->
    <v-app-bar app color="#00a170" elevation="1" dark>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="d-flex"
      ></v-app-bar-nav-icon>      
      <v-toolbar-title>
        <v-avatar class="m-1">
          <img src="@/assets/PolyU-logo-white.png">
        </v-avatar>
        <v-avatar class="m-1">
          <img src="@/assets/AP-logo-white.png">
        </v-avatar>
        <div class="ml-2" style="display:inline-block">Borderless Lab 365</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu v-model="languageMenu" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="text-capitalize mr-3" color="#36a16f" v-bind="attrs" v-on="on"  rounded>
            <v-icon>mdi-web</v-icon>   
            <!--{{ activeLang }}-->
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(lang, index) in langs" :key="index" @click="handleMenuItemClick(lang)">
            <v-list-item-title>{{ lang.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-if="$store.state.user.logged_in!=true"
        class='px-5 mr-3'
        color='#248557'
        rounded
        @click="goTo('/login')"
      >
        {{ $t("top_nav.login") }}
      </v-btn>
      <v-menu v-else-if="$store.state.user.logged_in" offset-y>        
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class='px-5 mr-3'
            color='#248557'
            rounded
            v-bind="attrs"
            v-on="on"
          >
            <v-icon class="pr-1">mdi-account-circle</v-icon>{{ $cookies.get('username') }}
          </v-btn>
        </template>
        <v-list class="p-0">
          <v-list-item @click="goTo('/logout')">
            <v-list-item-content>
              {{ $t("top_nav.logout") }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
          <small v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'">({{ $t("login.user_level_prompt") }}{{ $cookies.get('user_level') }})</small>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      mini-variant-width="90" 
      color="#29684a"
      dark
    >
      <v-list-item  class="text-center">
        <v-list-item-content>
          <v-avatar tile>
            <img style="cursor: pointer" src="@/assets/remote-lab-logo.png" @click="redirect('https://stem-ap.polyu.edu.hk/remotelab/')">
          </v-avatar>
          <h5>Borderless Lab 365</h5>
        </v-list-item-content>
      </v-list-item>
      
      <v-divider></v-divider>
      <v-list rounded>
        <v-list-item-group>
          <v-list-item @click="goTo('/announcement')">
            <v-list-item-icon>
              <v-icon>mdi-bullhorn</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.announcement") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>          
          <v-list-item v-if="$cookies.get('user_level')=='USER'||$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'" @click="goTo('/booking')">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.booking") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$cookies.get('user_level')=='INCHARGE'" @click="goTo('/management/school')">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.management") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$cookies.get('user_level')=='ADMIN'" @click="goTo('/management')">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.management") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>          
          <v-list-item v-if="$cookies.get('user_level')=='USER'||$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'" @click="goTo('/document')">
            <v-list-item-icon>
              <v-icon>mdi-file</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("nav.document") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <br>
      <br>
      <v-list dense class="pt-0" style="background: rgba(256,256,256,0.2); width: 100%">
        <v-subheader>Supported by:</v-subheader>
        <v-list-item style="padding: revert;">
          <v-list-item-content>
            <v-list-item-title @click="redirect('https://www.qef.org.hk/')">
              <img style="max-height:50px; cursor: pointer" src="@/assets/QEF_logo_full.png" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item style="padding: 0 12px;">
          <v-list-item-content>
            <v-list-item-title @click="redirect('https://www.polyu.edu.hk/')">
              <img style="max-height:40px; cursor: pointer" src="@/assets/PolyU_icon_full.png" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title @click="redirect('https://www.polyu.edu.hk/ap/')">
              <img style="max-height:40px; cursor: pointer" src="@/assets/AP_logo_full.png" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <div class="caption text-center" style="color: rgba(255, 255, 255, 0.7);">Version: 202511.2</div>
      </v-list>
    </v-navigation-drawer>
    <!-- Navigation bar ends -->
    
    <v-main>
      <router-view class="mx-4" @kickTime="updateKickTime"/>
    </v-main>
    <v-footer padless>
      <v-col
        class="teal darken-4 p-0 text-center white--text caption"
        cols="12"
      >
        Copyright © {{ new Date().getFullYear() }} Department of Applied Physics. The Hong Kong Polytechnic University. All Rights Reserved.
      </v-col>
      
    </v-footer>

    <v-snackbar v-model="$store.state.snackbar.modal">
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-if="$i18n.locale=='tc'" color="pink" text v-bind="attrs" @click="snackbar = false">
          關閉
        </v-btn>
        <v-btn v-else color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!--v-content class="ma-5" style="background:#fff">
      <v-tabs-items v-model="tab" class="d-flex flex-column align-center">
        <v-tab-item v-for="item in items" :key="item">
          You are on {{ item }}
        </v-tab-item>
      </v-tabs-items>
    </v-content-->
  </v-app>
</template>

<script>

import { api_general } from "@/services/iot/api_general";
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);
export default {
  props: {
    source: String,
  },
  data: () => ({
    langs: [
        { title: 'English', value: 'en' },
        { title: '繁中', value: 'tc' },
      ],
    activeLang: 'English',
    dialog: false,
    languageMenu: false,
    tile_img: "@/assets/remote-lab-logo.png",
    username: '',
    drawer: true,
    tab: null,
    items: [
      {
        action: 'mdi-home',
        title: 'Home',
      },
      {
        action: 'mdi-newspaper-variant',
        title: 'News',
      },
      {
        action: 'mdi-cog',
        items: [
          { title: 'Experiment', url: '/about'},
          { title: 'School', url: '/school' },
        ],
        title: 'Management',
      },
      {
        action: 'mdi-information',
        title: 'About',
      },
    ],
    selectedItem: 1,
    nav_item: {
      null: [
        { text: 'Home', icon: 'mdi-home', url: '/home' },
        { text: 'About', icon: 'mdi-information', url: '/about' },
        { text: 'News', icon: 'mdi-newspaper-variant', url: '/news' },
      ],
      ADMIN: [
        { text: 'Home', icon: 'mdi-home', url: '/home' },
        { text: 'About', icon: 'mdi-information', url: '/about' },
        { text: 'News', icon: 'mdi-newspaper-variant', url: '/news' },
        { text: 'Booking', icon: 'mdi-calendar', url: '/booking' },
        { text: 'Management', icon: 'mdi-cog', url: '/management/'},
        { text: 'Document', icon: 'mdi-file', url: '/document' },
      ],
      INCHARGE: [
        { text: 'Home', icon: 'mdi-home', url: '/home' },
        { text: 'About', icon: 'mdi-information', url: '/about' },
        { text: 'News', icon: 'mdi-newspaper-variant', url: '/news' },
        { text: 'Booking', icon: 'mdi-calendar', url: '/booking' },
        { text: 'Management', icon: 'mdi-cog', url: '/management/school/'},
        { text: 'Document', icon: 'mdi-file', url: '/document' },
      ],
      USER: [
        { text: 'Home', icon: 'mdi-home', url: '/home' },
        { text: 'About', icon: 'mdi-information', url: '/about' },
        { text: 'News', icon: 'mdi-newspaper-variant', url: '/news' },
        { text: 'Booking', icon: 'mdi-calendar', url: '/booking' },
        { text: 'Document', icon: 'mdi-file', url: '/document' },
      ],
    },
    page:"",
    msg: "",
    auth_token: "",
    setupDialog: false,
    feedbackDialog: false,
    mini: false,
    kick_time: 0,
    logged: false,
    feedbackCategory: "",
    feedbackDetails: "",
    feedbackEmail: "",
    feedbackUser: "",
    feedbackExperiment: "",
    feedbackEquipment: "",
  }),
  mounted: function () {
    var self = this;
    if( !(self.$cookies.get('username')=='' || self.$cookies.get('username')==undefined) ){
      self.$store.state.current.logged_in = true;
      self.username = self.$cookies.get('username');
    }
    if( !(self.$cookies.get('user_level')=='' || self.$cookies.get('user_level')==undefined) ){
      self.$store.state.current.user_level = self.$cookies.get('user_level');
    }
    self.getUserInfo();
    self.changeLanguage();    
  },
  methods: {
    getUserInfo(){
      var self = this;
      //if( self.$cookies.get('username')!='' && self.$cookies.get('username')!=undefined ){
        apiGeneral
          .getUserInfo(self.$cookies.get("username"))
          .then((response) => {
            let username = null;
            let user_level = null;
            let school_id = null;
            let school_name = null;
            let school_chi_name = null;
            let logged_in = false;
            if (response.status == "fail") {
              self.$store.commit("updateUserInfo", {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token});
            } else {
              username = response.username;
              user_level = response.user_level;
              school_id = response.school_id;
              school_name = response.school_name;
              school_chi_name = response.school_chi_name;
              logged_in = true;
              self.$cookies.username = username;
              self.$cookies.user_level = response.user_level;
              self.$cookies.school_id = response.school_id;
              self.$store.commit("updateUserInfo", {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token});
            }
          });
      //}
    },
    updateKickTime(time) {
      this.kick_time = time;
    },
    labelExperiment: function (name) {
      switch (name) {
        case "interference":
          this.experiment = "Interference";
          break;
        case "visible_spectrum":
          this.experiment = "Visible Spectrum";
          break;
        case "emission_spectrum":
          this.experiment = "Emission Spectrum";
          break;
        case "apparent_depth":
          this.experiment = "Apparent Depth";
          break;
        case "bacteria_growth":
          this.experiment = "Bacteria Growth";
          break;
        case "em_induction":
          this.experiment = "EM Induction";
          break;
        case "green_house":
          this.experiment = "Green House";
          break;
        case "photo_electric":
          this.experiment = "Photo Electric";
          break;
        case "radiation":
          this.experiment = "Radiation";
          break;
        case "titration":
          this.experiment = "Titration";
          break;
        case "ultrasound":
          this.experiment = "Ultrasound";
          break;
        case "respiration":
          this.experiment = "Respiration";
          break;
        case "photosynthesis":
          this.experiment = "Photosynthesis";
          break;
        case "identify_unknown_anion":
          this.experiment = "Identify Unknown Anion";
          break;
        case "kinetic_rate":
          this.experiment = "Kinetic Rate";
          break;
        case "new_interference":
          this.experiment = "New Interference";
          break;        
        case "capacitance":
          this.experiment = "Capacitance";
          break;
      }
    },
    goTo: function (name) {
      var self = this;
      let path = self.$route.path;
      let con = "^"+name;
      let reg = new RegExp(con, "g");
      let exc = false;
      console.log(name, path)
      if(name=="/management" && name!=path){
        exc = true;
      }
      if(!reg.test(path) ){
        self.$router.push(name);
      }
      else if(exc == true ) {
        self.$router.push(name);
      }
      else {
        console.log("same");
      }
    },
    handleMenuItemClick (lang) {
      var self = this;
      self.activeLang = lang.title;
      self.$i18n.locale = lang.value;
      self.$cookies.set("locale", lang.value);

    },
    changeLanguage: function () {
      var self = this;
      var systemLang = window.navigator.language.split('-')[0] || window.navigator.userLanguage.split('-')[0];
      if(self.$cookies.get('locale') != undefined && self.$cookies.get('locale')!=""){
        if(self.$cookies.get('locale')=='tc'){
          self.$cookies.set("locale", 'tc');
          self.activeLang = "繁中";
          self.$i18n.locale = 'tc';
        }
        else {
          self.$cookies.set("locale", 'en');
          self.activeLang = "English";
          self.$i18n.locale = 'en';
        }
      }
      else {
        if(systemLang=="zh"){
          self.$cookies.set("locale", 'tc');
          self.activeLang = "繁中";
          self.$i18n.locale = 'tc';
        }
        else {
          self.$cookies.set("locale", 'en');
          self.activeLang = "English";
          self.$i18n.locale = 'en';
        }
      }
    },
    openManual() {
      window.open(
        this.$store.state.experiments[this.$route.params.experiment_name]
          .labManual
      );
    },
    redirect(url){
      window.open(url);
    },
    syncFeedback() {
      var self = this;
      self.feedbackUser = self.$cookies.get("username");
      if (self.feedbackUser == null) {
        self.logged = false;
        self.feedbackUser = "";
      } else {
        self.logged = true;
        self.feedbackUser = self.$cookies.get("username");
      }
      self.feedbackExperiment = self.$cookies.get("experiment");
      if (self.feedbackExperiment == null) {
        self.feedbackExperiment = self.$route.params.experiment_name;
        if (self.feedbackExperiment == null) {
          self.feedbackExperiment = null;
        }
      }
      self.feedbackEquipment = self.$cookies.get("equipment_id");
    },
    submitFeedback() {
      var self = this;
      const url =
        "https://hooks.slack.com/services/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";
      const data = {
        text:
          "User Feedback" +
          "\n" +
          "User: " +
          this.feedbackUser +
          "\n" +
          "Email Address: " +
          this.feedbackEmail +
          "\n" +
          "Experiment: " +
          this.feedbackExperiment +
          "\n" +
          "Set: " +
          this.feedbackEquipment +
          "\n" +
          "feedbackCategory: " +
          this.feedbackCategory +
          "\n" +
          "feedbackDetails: " +
          this.feedbackDetails +
          "\n" +
          "\n",
      };
      this.axios.post(url, JSON.stringify(data), {
        withCredentials: false,
        transformRequest: [
          (data, headers) => {
            delete headers.post["Content-Type"];
            return data;
          },
        ],
      });
      alert("Thank you for your feedback!");
      self.feedbackDialog = false;
    },
    routing(url){
      var self = this;
      self.$router.push(url);
    },
  },
};
</script>
<style lang="scss">
.chem-btn {
  text-transform: unset !important;
}
.v-list .v-list-item--active{
  color: #80ffcf !important;
}

::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(76, 78, 76); 
  border-radius: 10px;
}

::-webkit-scrollbar-track-piece {
  background: #bac5bb;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #5ab98e; 
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #4ba07a; 
}


</style>